import React, { useEffect } from 'react'
import ProductCard from '../../cards/ProductCard'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import SectionHeader from '../SectionHeader';
import { useDispatch, useSelector } from 'react-redux';
import { getProducts } from '../../../services/actions/MainAction';
function ProductSection({more=false}) {
    const contentData = useSelector(state => state.Data.contentData);
    const lang_id = useSelector(state => state.Data.lang_id);
    const productsData = useSelector(state => state.Data.productsData);
    const dispatch = useDispatch();
    useEffect(()=>{
      dispatch(getProducts(lang_id))
    },[lang_id])
    const responsive = {
      superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 1200 },
        items: 4
      },
      desktop: {
        breakpoint: { max: 1200, min: 800 },
        items: 3,
      },
      tablet: {
        breakpoint: { max: 800, min: 600 },
        items: 2
      },
      mobile: {
        breakpoint: { max: 600, min: 0 },
        items: 1
      }
    };
  return (
    <section className='mt-[50px]' >
        <div className=''>
            <SectionHeader title={contentData?.section_1} />
            <div className='gap-[20px] mt-[20px] px-[40px] max-[600px]:px-[20px]'>
                <Carousel 
                    swipeable={true}
                    draggable={true}
                    showDots={false}
                    responsive={responsive}
                    ssr={true} 
                    infinite={true}
                    autoPlay={true}
                    autoPlaySpeed={2000}
                    keyBoardControl={true}
                    customTransition="all 2s"
                    transitionDuration={2000}
                    containerClass=""
                    dotListClass="custom-dot-list-style"
                    itemClass="carousel-item-padding-40-px"
                    
                  >
                    {
                      productsData?.map((data, i)=>{
                        return (
                          <ProductCard key={i} data={data} />
                        )
                      })
                    }
                </Carousel>
                
            </div>
        </div>
    </section>
  )
}

export default ProductSection